import axios from "src/lib/axios";

export const getAllBlog = ({
  keyword = null,
  page = null,
  page_size = null,
}) => {
  return axios.get(`/blogs/find-all`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      order_case: "desc",
      manage: true,
    },
  });
};
export const getBlogDetail = (id) => axios.get(`/blogs/blog-detail/${id}`);

export const createBlogByAdmin = (data) => {
  return axios.post(`/blogs/create-blog`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

export const updateBlogByAdmin = (data) => {
  return axios.patch(`/blogs/update-blog`, data);
};

export const deleteBlogByAdmin = (id) =>
  axios.delete(`/blogs/delete-blog/${id}`);

export const toggleBlogVisibility = (id) =>
  axios.patch(`/blogs/toggle-visibility/${id}`);
